import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import setImageSizeParams from "../../../../utils/setImageSizeParams"

// Outer container wrapping blog tile content
const ArticleTileContainer = styled.div`
	margin-bottom: 32px;
	@media (max-width: 767px) {
		display: grid;
		grid-template-columns: 1fr 2fr;
		margin-bottom: 16px;
	}
`

const ArticleTitleSmall = styled.h5`
	max-width: 286px;
	color: #070808;
	font-family: Mallory-Book !important;
	font-size: 14px;
	font-weight: 300;
	line-height: 24px;
	margin-top: 0;
	margin-bottom: 22px;
	@media (max-width: 767px) {
		margin-top: 12px;
		grid-column: 2/2;
		grid-row: 1/2;
		margin-left: 12px;
		font-family: Mallory-Book !important;
		margin-top: 30px;
	}
`

const ArticleTileImage = styled.img`
	min-height: 286px;
	width: 286px;
	object-fit: cover;
	@media (max-width: 767px) {
		min-height: 120px;
		max-height: 120px;
		width: 120px;
		grid-column: 1/2;
	}
`

const ArticleTileImageContainer = styled.div`
	min-height: 228px;
	width: 286px;
	// object-fit: cover;
	@media (max-width: 767px) {
		min-height: 120px;
		max-height: 120px;
		width: 120px;
		grid-column: 1/2;
	}
`

const ReadMoreSmall = styled.span`
	color: #777777;
	font-family: Mallory;
	font-size: 14px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 20px;
	text-decoration: underline;
	@media (max-width: 767px) {
		grid-column: 2/2;
		grid-row: 1/2;
		margin-left: 12px;
		margin-top: 90px;
	}
`

const LinkWrapper = styled.a`
	text-decoration: none;
`

const TagsSmall = styled.p`
	color: #747474;
	font-family: Mallory;
	font-size: 12px;
	font-weight: 500;
	letter-spacing: 1px;
	line-height: 14px;
	margin-bottom: 0;
	margin-top: 12px;
	@media (max-width: 767px) {
		grid-column: 2/2;
		grid-row: 1/2;
		margin-left: 12px;
		margin-top: 12px;
	}
`

export const ArticleTile = (props) => {
	const link = `/blogs/all/${props.slug}`
	const tag = props.tag?.replace("-", " ")
	const [imageUrl, setImageUrl] = useState("")

	useEffect(() => {
		if (props.homeImg) {
			setImageUrl(props.homeImg)
			return
		}

		if (!props.img) return

		setImageUrl(props.img)
	}, [props.img, props.homeImg])

	return (
		<LinkWrapper href={link}>
			<ArticleTileContainer>
				<ArticleTileImage id="article-tile-image" src={imageUrl} />
				<TagsSmall>{tag ? tag.toUpperCase() : ""}</TagsSmall>
				{props.isMobile ? (
					<ArticleTitleSmall>
						{props.name?.length <= 48 ? (
							props.name
						) : (
							<>
								{props.name?.substr(0, 48)}
								<span>...</span>
							</>
						)}
					</ArticleTitleSmall>
				) : (
					<ArticleTitleSmall>{props.name}</ArticleTitleSmall>
				)}
				<ReadMoreSmall>Read more</ReadMoreSmall>
			</ArticleTileContainer>
		</LinkWrapper>
	)
}
